<template>
  <!--begin::Advance Table Widget 9-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <div class="card-toolbar">
        <a
          href="#"
          class="btn btn-primary font-weight-bolder font-size-sm"
          @click.prevent="onUploadFileClicked()"
        >
          <i class="menu-icon flaticon2-plus" style="font-size: 1em"></i>{{ $t('TODO.UPLOAD_FILE') }}
        </a>

        <div v-if="files.length === 0">
          <span class="svg-icon svg-icon svg-icon-xl">
            <inline-svg id="animated-svg" class="svg-icon" src="/assets/svg/Angle-double-left.svg" />
          </span>
        </div>

      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-0 pb-3">
      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
          <thead>
            <tr class="text-left">
              <th style="min-width: 110px">Namn</th>
              <th style="min-width: 110px">Datum</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in files">
              <FileTableRow
                v-bind:key="i"
                :file="item"
                :type="type"
                :currentCompanyId="currentCompanyId"
                @downloadFileClicked="downloadFileClicked"
                @selectFileClicked="selectFileClicked"
                @deleteFileClicked="deleteFileClicked"
              />
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
  </div>
  <!--end::Advance Table Widget 9-->
</template>
<style lang="scss" scoped>


@keyframes move-left {
  0% {
    transform: translateX(40px);
  }
  50% {
    transform: translateX(10px); /* Adjust the distance you want to move */
  }
  100% {
    transform: translateX(40px);
  }
}

#animated-svg {
  animation: move-left 1.4s ease-in-out infinite; /* Adjust duration as needed */
}

</style>
<script>
import axios from 'axios';
import FileTableRow from '@/view/pages/ml/todowizard/FileTableRow.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'shop_items-table',
  props: {
    files: Array,
    currentCompanyId: String,
    type: String,
    taskStatus: {type: String, default: 'CLOSE'}
  },
  emits: ['downloadFileClicked', 'selectFileClicked', 'deleteFileClicked', 'onUploadFileClicked'],
  mixins: [ toasts ],
  components: {
    FileTableRow
  },
  watch: {
    files(newValue, oldvalue) {

    }
  },
  mounted() {

  },
  methods: {
    downloadFileClicked(file_id) {
      this.$emit('downloadFileClicked', file_id);
    },

    selectFileClicked(file_id) {
      this.$emit('selectFileClicked', file_id);
    },
    deleteFileClicked(file_id) {
      this.$emit('deleteFileClicked', file_id);
    },
    onUploadFileClicked() {
      this.$emit('onUploadFileClicked');
    }
  },
  data() {
    return {
      list: []
    };
  }
};
</script>
